var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.18,
    height: 22.525,
    viewBox: "0 0 36.18 22.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24923",
    "data-name": "Group 24923",
    transform: "translate(-0.311 -1.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24404",
    "data-name": "Group 24404",
    transform: "translate(0.811 1.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12655",
    "data-name": "Path 12655",
    d: "M20.314,18.408l-3.986,1.151a.374.374,0,0,1-.476-.395l1.79-6.129-9.82,2.8-1.929.808-1.479-.608.273-1.885-2.668-3.9A.374.374,0,0,1,2,9.922a.366.366,0,0,1,.252-.215l2.929-.718a.374.374,0,0,1,.374.118L7.9,11.82l8.721-2.774L11.31,4.156a.374.374,0,0,1,.183-.6l3.127-.9a.375.375,0,0,1,.31.047L23.7,6.692l4.022-.923c5.469-1.172,7.672-.084,8.006,1.073.5,1.727-3.572,2.972-7.163,4.066,0,0-2.036.626-2.94.9,0,0-5.039,6.314-5.065,6.381A.375.375,0,0,1,20.314,18.408Z",
    transform: "translate(-1.636 -2.64)",
    fill: "none",
    stroke: "#0b2055",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_558",
    "data-name": "Line 558",
    x1: 4.336,
    y2: 1.252,
    transform: "translate(17.728 4.052)",
    fill: "none",
    stroke: "#0b2055",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_559",
    "data-name": "Line 559",
    x2: 35.18,
    transform: "translate(0 21.523)",
    fill: "none",
    stroke: "#0b2055",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutbound);
export default __webpack_public_path__ + "static/media/outbound.74307cf61185e7f39b39b95c7bce94b5.svg";
export { ForwardRef as ReactComponent };